import { useCompanyId } from 'application/providers/AccountProvider';

import { useBillingCompanyBillingInfoQuery } from 'domain/api/graphql/generated';
import { FetchPolicyKeys } from 'domain/api/graphql/types';

import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';
import TimezoneUtils from '@zvuk-b2b/react-uikit/toolkit/TimezoneUtils';

interface UseChangePricePlanPeriodConfirmModalViewModel {
  renewableLicensesLength: number;
  hasTrialLicenses: boolean;
  formatNextBillingDate: string;
  loading: boolean;
  hasInactiveLicenses: boolean;
}

const useChangePricePlanPeriodConfirmModalViewModel = (): UseChangePricePlanPeriodConfirmModalViewModel => {
  const companyId = useCompanyId();

  const { data, loading } = useBillingCompanyBillingInfoQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
    variables: { companyId },
  });

  const nextBillingDate = data?.result?.nextBillingDate;
  const renewableLicenses = data?.result?.renewableLicenses || [];
  const hasTrialLicenses = Boolean(data?.result?.hasTrialLicenses);
  const hasInactiveLicenses = Boolean(data?.result?.hasInactiveLicenses);

  const dateWithoutTimezoneOffset = TimezoneUtils.getDateWithoutTimezoneOffset(nextBillingDate);
  const formatNextBillingDate = DateUtils.getFormatDateFrom(dateWithoutTimezoneOffset, 'dd MMMM yyyy');

  return {
    renewableLicensesLength: renewableLicenses.length,
    hasTrialLicenses,
    formatNextBillingDate,
    loading,
    hasInactiveLicenses,
  };
};

export default useChangePricePlanPeriodConfirmModalViewModel;
